export const FETCH_MY_PROFILE = 'FETCH_MY_PROFILE'
export const FETCH_MY_PROFILE_SUCCESS = 'FETCH_MY_PROFILE_SUCCESS'
export const FETCH_MY_PROFILE_ERROR = 'FETCH_MY_PROFILE_ERROR'

export const FETCH_CITIES = 'FETCH_CITIES'
export const FETCH_CITIES_SUCCESS = 'FETCH_CITIES_SUCCESS'
export const FETCH_CITIES_ERROR = 'FETCH_CITIES_ERROR'

export const FETCH_REGIONS = 'FETCH_REGIONS'
export const FETCH_REGIONS_SUCCESS = 'FETCH_REGIONS_SUCCESS'
export const FETCH_REGIONS_ERROR = 'FETCH_REGIONS_ERROR'

export const SEARCH_CITIES = 'SEARCH_CITIES'
export const SEARCH_CITIES_SUCCESS = 'SEARCH_CITIES_SUCCESS'
export const SEARCH_CITIES_ERROR = 'SEARCH_CITIES_ERROR'

export const SET_DEFAULT_IMAGE = 'SET_DEFAULT_IMAGE'
export const SET_DEFAULT_IMAGE_SUCCESS = 'SET_DEFAULT_IMAGE_SUCCESS'
export const SET_DEFAULT_IMAGE_ERROR = 'SET_DEFAULT_IMAGE_ERROR'

export const DELETE_IMAGE = 'DELETE_IMAGE'
export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS'
export const DELETE_IMAGE_ERROR = 'DELETE_IMAGE_ERROR'

export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR'

export const UPLOAD_PHOTO = 'UPLOAD_PHOTO'
export const UPLOAD_PHOTO_SUCCESS = 'UPLOAD_PHOTO_SUCCESS'
export const UPLOAD_PHOTO_ERROR = 'UPLOAD_PHOTO_ERROR'
